import { useEffect, useState } from 'react';
import { Toaster } from 'react-hot-toast';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import About from './pages/About';
import ActiveComplaints from './pages/ActiveComplaints';
// import AdminDashboard from './pages/admin/AdminDashboard';
import AllComplaints from './pages/AllComplaints';
import ComplaintList from './pages/ComplaintList';
import ComplaintStatus from './pages/ComplaintStatus';
import CompletedComplaints from './pages/CompletedComplaints';
import Dashboard from './pages/Dashboard';
import LoginRegistration from './pages/LoginRegistration';
import MyAttendance from './pages/MyAttendance';
import MyComplaints from './pages/MyComplaints';
import NotFound from './pages/NotFound';
import Profile from './pages/Profile';
import Unauthorized from './pages/Unauthorized';
import UserManagement from './pages/UserManagement';
import { subscribeToComplaintsCount } from './services/complaintsCountService';
import { loadAllComplaintData } from './services/complaintService';
import AdminAttendance from './pages/admin/AdminAttendance';
import Attendance from './pages/Attendance';
import LiveTracking from './pages/admin/LiveTracking';
import AdminLayout from './components/admin/AdminLayout';
import ComplaintTypes from './pages/admin/ComplaintTypes';
import ComplaintCategories from './pages/admin/ComplaintCategories';

function App() {
  const [dataLoaded, setDataLoaded] = useState(false);

  useEffect(() => {
    const loadData = async () => {
      try {
        // Load complaint categories and types
        await loadAllComplaintData();

        // Initialize complaints count listener
        const unsubscribe = subscribeToComplaintsCount((counts) => {
          // Counts are automatically updated in the hook
          // No need to do anything here unless you want to log
          // console.log('Complaints count updated:', counts);
        });

        setDataLoaded(true);

        // Cleanup on unmount
        return () => {
          unsubscribe();
        };
      } catch (error) {
        console.error('Failed to load complaint data:', error);
        setDataLoaded(true);
      }
    };

    loadData();
  }, []);

  // Loading state
  if (!dataLoaded) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 border-4 border-pink-500 border-t-transparent rounded-full animate-spin"></div>
          <p className="text-gray-600 font-medium">Loading application...</p>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <Toaster
        position="bottom-center"
        reverseOrder={false}
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
          },
          success: {
            duration: 3000,
            iconTheme: {
              primary: '#22c55e',
              secondary: '#fff',
            },
          },
          error: {
            duration: 4000,
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fff',
            },
          },
        }}
      />

      <Routes>
        {/* Public Routes - No authentication required */}
        <Route path="/auth" element={<LoginRegistration />} />
        <Route path="/complaint/:id" element={<ComplaintStatus />} />
        <Route path="/about" element={<About />} />
        <Route path="/unauthorized" element={<Unauthorized />} />

        {/* Protected Routes - Authentication required */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />

        <Route
          path="/complaints"
          element={
            <ProtectedRoute>
              <AllComplaints />
            </ProtectedRoute>
          }
        />

        <Route
          path="/complaints/:category"
          element={
            <ProtectedRoute>
              <ComplaintList />
            </ProtectedRoute>
          }
        />

        <Route
          path="/complaints/completed"
          element={
            <ProtectedRoute>
              <CompletedComplaints />
            </ProtectedRoute>
          }
        />

        <Route
          path="/active-complaints"
          element={
            <ProtectedRoute>
              <ActiveComplaints />
            </ProtectedRoute>
          }
        />

        <Route
          path="/my-complaints"
          element={
            <ProtectedRoute>
              <MyComplaints />
            </ProtectedRoute>
          }
        />
        <Route path="/attendance" element={
          <ProtectedRoute>
            <Attendance />
          </ProtectedRoute>
        } />

        <Route path='/my-attendance'
          element={<ProtectedRoute>
            <MyAttendance />
          </ProtectedRoute>} />

        <Route
          path="/admin"
          element={
            <ProtectedRoute requiredRoles={['admin']}>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          {/* No index route – redirect to categories */}
          <Route index element={<Navigate to="/admin/categories" replace />} />
          <Route path="categories" element={<ComplaintCategories />} />
          <Route path="types" element={<ComplaintTypes />} />
          <Route path="attendance" element={<AdminAttendance />} />
          <Route path="admin-attendance" element={<AdminAttendance />} />
          <Route path="live-tracking" element={<LiveTracking />} />
          <Route path="users" element={<UserManagement />} />
        </Route>

        {/* Catch all - 404 Not Found */}
        <Route path="/404" element={<NotFound />} />
        <Route path="*" element={<Navigate to="/404" replace />} />
      </Routes>
    </Router>
  );
}

export default App;

// import { useEffect, useState } from 'react';
// import { Toaster } from 'react-hot-toast';
// import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
// import About from './pages/About';
// import ActiveComplaints from './pages/ActiveComplaints';
// import AdminDashboard from './pages/admin/AdminDashboard';
// import AllComplaints from './pages/AllComplaints';
// import ComplaintList from './pages/ComplaintList';
// import ComplaintStatus from './pages/ComplaintStatus';
// import CompletedComplaints from './pages/CompletedComplaints';
// import Dashboard from './pages/Dashboard';
// import LoginRegistration from './pages/LoginRegistration';
// import Profile from './pages/Profile';
// import UserManagement from './pages/UserManagement';
// import { loadAllComplaintData } from './services/complaintService';
// import MyComplaints from './pages/MyComplaints';

// function App() {
//   const [dataLoaded, setDataLoaded] = useState(false);

//   useEffect(() => {
//     const loadData = async () => {
//       try {
//         await loadAllComplaintData();
//         setDataLoaded(true);
//       } catch (error) {
//         console.error('Failed to load complaint data:', error);
//         // Even if fails, continue - maybe use empty data
//         setDataLoaded(true);
//       }
//     };

//     loadData();
//   }, []);

//   // Optional: Show loading state if needed
//   if (!dataLoaded) {
//     return (
//       <div className="min-h-screen flex items-center justify-center bg-gray-50">
//         <div className="flex flex-col items-center gap-4">
//           <div className="w-12 h-12 border-4 border-pink-500 border-t-transparent rounded-full animate-spin"></div>
//           <p className="text-gray-600">Loading application...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <Router>
//       <Toaster position="bottom-center" reverseOrder={false} />
//       <Routes>
//         <Route path="/auth" element={<LoginRegistration />} />
//         <Route path="/complaint/:id" element={<ComplaintStatus />} />
//         <Route index element={<Dashboard />} /> {/* default page */}

//         {/* Dashboard routes with layout */}
//         {/* <Route element={<DashboardLayout />}> */}
//         <Route path="/complaints" element={<AllComplaints />} />
//         <Route path="/complaints/:category" element={<ComplaintList />} />
//         <Route path="/complaints/completed" element={<CompletedComplaints />} />

//         <Route path="/admin/users" element={<UserManagement />} />
//         <Route path="/admin" element={<AdminDashboard />} />
//         <Route path="/active-complaints" element={<ActiveComplaints />} />
//         <Route path="/about" element={<About />} />
//         <Route path="/profile" element={<Profile />} />
//         <Route path="/my-complaints" element={<MyComplaints />} />
//         {/* </Route> */}
//       </Routes>
//     </Router>
//   );
// }

// export default App;


